import * as React from "react";

export const DebugInfoEnabledContext = React.createContext<boolean>(false);
